<template>
  <v-row no-gutters>
    <v-col cols="12" class="pa-0">
      <skeleton-list v-if="loading !== null ? loading : ($store.state.accounts.LoaderMe || $store.state.purchases.retrieveLoader)" />
      <template v-else>
        <PermissionDenied v-if="!$helpers.hasPermission(['view_pending_receipt'])" />
        <template v-else>
          <v-empty-state :class="{'pt-6 pb-0' : routeList.includes($route.name)}" v-if="!purchasesList.length || (!routeList.includes($route.name) && !Object.keys($route?.query).length)" type="documents" id="documentos"
          :customClass="routeList.includes($route.name) ? 'mt-0 pb-2' : 'mt-0'" :isFree="routeList.includes($route.name)" title="No existen documentos para mostrar" :height="routeList.includes($route.name) ? 100 : 280" :minHeight="routeList.includes($route.name) ? 'auto' : 'calc(100vh - 300px)'" :hiddenDescription="hiddenBtnEmpty">
            <template v-slot:actions>
              <template v-if="!routeList.includes($route.name) && hiddenBtnEmpty">
                <v-btn @click="$emit('activeBtnFilter')" color="grey-900" :ripple="false" :width="153"><v-icon class="mr-2">mdi-filter-plus</v-icon>Filtrar</v-btn>
                <v-btn class="ml-2" @click="latestRecords()" outlined :ripple="false" width="153"><v-icon class="mr-2">mdi-text-search-variant</v-icon>Últimos registros</v-btn>
              </template>
            </template>
          </v-empty-state>
          <template v-else>
            <v-data-table
              :class="[{'table-not-rounded' : ['SupplierRetrieveUpdate'].includes($route.name)}, {'fixed-table' : $store.state.base.isExpandNavigationDrawer}]"
              :headers="currentHeader"
              :items="purchasesList"
              :items-per-page="pageSize || pagination"
              hide-default-header
              disable-sort
              mobile-breakpoint
              hide-default-footer
              @click:row="(purchasesList) => {goTo(purchasesList.id)}"
              style="cursor: pointer;"
              v-model="selected"
              item-key="id"
              :show-select="!routeList.includes($route.name)"
              checkbox-color="green-500"
              :fixed-header="!routeList.includes($route.name)"
              :height="heightTable"
            >
              <!-- header -->
              <template v-slot:header="{ props: { headers } }">
                <VTableHeaders :headers="headers" @sort="setSort" @toggleAll="toggleAll" @isSelected="isSelected = $event" :resetCheckbox="resetCheckbox" @toggleDropdown="toggleDropdown = $event" />
                <v-divider style="position: absolute;  margin-top: -6px; margin-left: -5px ;z-index: 2; min-width: 100%" />
              </template>
              <!-- end header -->
            <template v-slot:[`item.supplier_name`]="{item}">
              <template v-if="item.supplier_name.length">
                <span :class="$route.name === 'SupplierRetrieveUpdate' ? 'body-2' : 'body-1 mb-n2'" class="d-inline-block text-truncate" style="max-width: 90%;">{{item.supplier_name}}</span>
                <span class="caption grey-300--text d-block" v-if="item.tax_id">{{$t('generals.RUT')}} {{item.tax_id}}</span>
              </template>
              <span class="body-2 text--disabled font-italic" v-else>Sin especificar</span>
            </template>
            <template v-slot:[`item.type`]="{item}">
              <span class="text-decoration-none grey-500--text">{{item.type | nameDocumentsType}}</span>
            </template>
            <template v-slot:[`item.number`]="{item}">
              <div class="d-flex align-center justify-end">
                <v-tooltip v-if="item.assignment_agency_status" color="grey-background" right transition="scale-transition" max-width="250">
                  <template v-slot:activator="{ on }">
                    <v-avatar v-on="on" color="grey-900" size="24" class="mr-2">
                      <v-icon color="white" size="12">mdi-file-arrow-left-right</v-icon>
                    </v-avatar>
                  </template>
                  <span class="d-block px-3 py-2">Documento cedido</span>
                </v-tooltip>
                <span class="body-1">{{item.number}}</span>
              </div>
            </template>
            <template v-slot:[`item.date`]="{item}">
              <span class="body-1">{{item.date | date}}</span>
            </template>
            <template v-slot:[`item.rec_status`]="{item}">
              <chip-status style="white-space: nowrap !important" type="purchases" :status="item.rec_status ? item.rec_status : 'CRE'" :isTooltip="true" />
            </template>
            <template v-slot:[`item.status`]="{item}">
              <chip-status v-if="item.status" style="white-space: nowrap !important" type="documents" :status="item.status ? item.status : 'CRE'" :detail="['SNT', 'FAI'].includes(item.status) ? `Última fecha de actualización: <br> ${updatedDate(item.updated)}` : null" :isActivePopover="['SNT', 'FAI'].includes(item.status)" :isTooltip="true" />
                <span class="text--disabled font-italic" v-else>Sin especificar</span>
            </template>
            <template v-slot:[`item.created`]="{item}">
                <span class="body-1">{{item.created | dateTime}}</span>
              </template>
            <template v-slot:[`item.rec_date`]="{item}">
              <span v-if="item.rec_date">{{item.rec_date | dateTime}}</span>
            </template>
            <template v-slot:[`item.assignee_info`]="{item}">
              <template v-if="item.assignee_name">
                <span class="body-1 mb-n2 d-inline-block text-truncate" style="max-width: 90%;">{{item.assignee_name}}</span>
                <span class="caption grey-300--text d-block" v-if="item.assignee_tax_id">{{$t('generals.RUT')}} {{item.assignee_tax_id}}</span>
              </template>
              <span class="text--disabled" v-else>---</span>
            </template>
            <template v-slot:[`item.amount_total`]="{item}">
              <div class="text-right">
                <span class="body-1">{{item.amount_total }}</span>
                <span class="grey-300--text caption ml-1">{{item.currency}}</span>
              </div>
            </template>
            <template v-slot:[`item.actions`]="{item}">
              <v-menu close-on-click close-on-content-click offset-y left :nudge-bottom="10" :nudge-left="10" transition="slide-y-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="mr-n4" v-bind="attrs" v-on="on" text x-small><v-icon color="grey-700" size="24">mdi-dots-vertical</v-icon></v-btn>
                </template>
                <v-list class="pa-0">
                  <v-list-item class="px-3" @click="current = item, renderDocument2('purchases', 'rec-docs', 'pdf', item.id), resetPDF += 1" :ripple="false">
                    <v-list-item-title class="body-1 grey-500--text d-flex align-center"><v-icon color="grey-700" small left>mdi-text-box</v-icon>Ver PDF</v-list-item-title>
                  </v-list-item>
                  <v-list-item class="px-3" @click="downloadFile2('purchases', `${item.type}_N${item.number}`, 'rec-docs', 'xml', item.id)" :ripple="false">
                    <v-list-item-title class="body-1 grey-500--text d-flex align-center"><v-icon color="grey-500" small left>mdi-code-braces-box</v-icon>Descargar XML</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
          <VMainPagination v-if="showPagination || showAll" titleShowAll="Ver todos los documentos" :count="count" :pageSize="pageSize" redirect="purchasesList" />
          </template>
        </template>
      </template>
      <!-- dialog pdf -->
      <v-dialog v-model="modalRender" width="700" persistent scrollable no-click-animation overlay-color="grey-500">
        <render-pdf :basicRender="true" :documentType="current.type | nameDocumentsType" :number="current.number" :loaderRender="loaderRender" :renderUrl="renderUrl" @close="modalRender=false" :showFormat="false" :key="resetPDF" />
      </v-dialog>
      <!-- end dialog pdf -->
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import moment from 'moment'
import SkeletonList from '@/components/commons/skeletonLoader/SkeletonList'
import VEmptyState from '@/components/commons/VEmptyState'
import RenderPdf from '@/components/files/RenderPdf'
import VTableHeaders from '@/components/VTable/VTableHeaders'
import ListViewMixin from '@/mixins/ListViewMixin'
import GenericViewMixin from '@/mixins/GenericViewMixin'
import RenderViewMixin from '@/mixins/RenderViewMixin'
import ChipStatus from '@/components/commons/ChipStatus'
import VMainPagination from '@/components/commons/VMainPagination'
import PermissionDenied from '@/modules/http/views/PermissionDenied'

export default {
  components: {
    ChipStatus,
    RenderPdf,
    VEmptyState,
    SkeletonList,
    VTableHeaders,
    VMainPagination,
    PermissionDenied
  },
  mixins: [
    ListViewMixin,
    GenericViewMixin,
    RenderViewMixin
  ],
  props: {
    headerList: {
      type: Array,
      default: () => ([])
    },
    pageSize: {
      default: null
    },
    loading: {
      type: Boolean,
      default: null
    }
  },
  data: () => ({
    resetPDF: 0,
    list: [],
    toggleDropdown: null,
    current: {},
    resetCheckbox: 0,
    isSelected: null,
    selected: [],
    env: process.env?.VUE_APP_MODE ?? 'ax',
    routeList: ['BranchRetrieveUpdate', 'PosRetrieveUpdate', 'DocumentsRetrieve', 'CustomerRetrieveUpdate', 'DocumentsBatchRetrieve', 'SupplierRetrieveUpdate']
  }),
  computed: {
    heightTable () {
      if (['BranchRetrieveUpdate', 'PosRetrieveUpdate', 'DocumentsRetrieve', 'CustomerRetrieveUpdate', 'DocumentsBatchRetrieve', 'SupplierRetrieveUpdate'].includes(this.$route.name)) {
        const rowHeight = 48
        const headerHeight = 48
        const minHeight = 95
        const calculatedHeight = (this.purchasesList.length * rowHeight) + headerHeight
        const maxHeight = this.$vuetify.breakpoint.height - 465
        return `${Math.max(minHeight, Math.min(calculatedHeight, maxHeight))}px`
      }
      if (this.$vuetify.breakpoint.height >= 800 && this.purchasesList.length < 17) return 'auto'
      return 'calc(100vh - 275px)'
    },
    ...mapState({
      count: state => state.purchases.woemailCount,
      purchasesList: state => state.purchases.woemailList || []
    }),
    currentParams () {
      let params = JSON.parse(JSON.stringify(this.$route.params))
      delete params.id
      return params
    },
    hiddenBtnEmpty () {
      if (!Object.keys(this.$route.query ?? {}).length) return true
      else if (this.purchasesList.length) return false
      return false
    },
    updatedDate () {
      return (date = null) => {
        return moment(date).format('DD MMM YYYY HH:mm')
      }
    },
    headersDetail () {
      return [
        { text: 'Proveedor', value: 'supplier_name', sortable: true },
        { text: 'Tipo de documento', value: 'type', sortable: true },
        { text: this.$t('generals.Folio #'), value: 'number', align: 'end', sortable: true },
        { text: 'Fecha', value: 'date', align: 'end', sortable: true, width: 30 },
        { text: 'E. C.', value: 'rec_status', width: 70 },
        { text: `E. ${this.$t('generals.SII')}`, value: 'status', width: 70 },
        { text: 'Total', value: 'amount_total', align: 'end', sortable: true, width: 30 }
      ]
    },
    currentHeader () {
      return this.headerList.length ? [...this.headerList] : [...this.headersDetail]
    }
  },
  watch: {
    selected (val) {
      if (val.length !== this.purchasesList.length) this.resetCheckbox += 1

      this.$emit('update:selectedDocuments', this.selected)
    },
    toggleDropdown (val) {
      if (['filtered', 'perPage', 'all'].includes(val)) {
        this.selected = this.purchasesList
        this.isSelected = true
      } else if (val === '') this.selected = []
      this.$emit('update:toggleDropdown', val)
    },
    headerList () {
      this.list = [...this.headerList].filter((item) => item.show)
    }
  },
  methods: {
    toggleAll () {
      this.selected = !this.isSelected ? [] : this.purchasesList
    },
    goTo (id = null) {
      this.$store.commit('base/SET_QUERY', this.$route.query)
      this.$router.push({ name: 'PendingReceiveRetrieve', params: { id: id, ...this.currentParams}})
    },
    latestRecords () {
      this.$router.replace({name: this.$route.name, params: this.currentParams, query: { ref: 'initial' } }).catch(() => {})
    }
  }
}
</script>
